const SituacaoTarefaEnum = {
  0: 'PENDENTE',
  10: 'EM_ANDAMENTO',
  20: 'AGUARDANDO',
  90: 'CONCLUIDO',
  99: 'CANCELADO'
}

export default SituacaoTarefaEnum



// WEBPACK FOOTER //
// ./client/enum/situacaoTarefa.js